// extracted by mini-css-extract-plugin
module.exports = {"note_slider":"Trashnote_note_slider__3Ube-"};